import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import MainComponent from './components/MainComponent';
import './App.css';
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from './theme';
import { GlobalStyles } from './global';
import { Provider } from 'react-redux';
import { ConfigureStore } from './redux/configureStore';

const store = ConfigureStore();

class App extends Component {

  constructor(props) {
    super();
    window.localStorage.getItem("theme") === "dark"
      ? (this.state = {
          theme: darkTheme,
        })
      : (this.state = {
          theme: lightTheme,
        });
    this.switchTheme = this.switchTheme.bind(this);
  }

  switchTheme() {
    if (this.state.theme === darkTheme) {
      this.setState({
        theme: lightTheme,
      });
      window.localStorage.setItem('theme', 'light');
    } else {
      this.setState({
        theme: darkTheme,
      });
      window.localStorage.setItem('theme', 'dark');
    }
  }

  render() {
    return (
      <Provider store={store}>
        <ThemeProvider theme={this.state.theme}>
          <>
            <GlobalStyles />
            <BrowserRouter>
              <MainComponent switchTheme={this.switchTheme} currentTheme={this.state.theme.name} />
            </BrowserRouter>
          </>
        </ThemeProvider>
      </Provider>
    );
  }
}

export default App;
